export const fireToast = ({ message = '', type = '', btnTxt = '' }) => {
  if (typeof window === 'undefined') return
  const event = new CustomEvent('toasterEvent', {
    bubbles: true,
    detail: { msg: message, type, btnTxt }
  })
  document.dispatchEvent(event)
}
